export default __webpack_public_path__ + "img/eErlOuKR.09ca6ed4.svg";